export const GAMMA_DESK_ID = '10000000-0000-4000-8000-000000000001';
